import { render, staticRenderFns } from "./GlCpuGauge.vue?vue&type=template&id=28a0ad5d&scoped=true&"
import script from "./GlCpuGauge.vue?vue&type=script&lang=js&"
export * from "./GlCpuGauge.vue?vue&type=script&lang=js&"
import style0 from "./GlCpuGauge.vue?vue&type=style&index=0&id=28a0ad5d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0ad5d",
  null
  
)

export default component.exports